import { invoicesAPI } from '@shared/apiClient';

const downloadBlob = (blob, filename) => {
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
};

export const ensureInvoiceForServiceCall = async (serviceCallId) => {
  const { data } = await invoicesAPI.getByServiceCall(serviceCallId);
  return data.invoice;
};

export const downloadInvoicePdf = async (invoiceId, invoiceNumber) => {
  const { data } = await invoicesAPI.downloadPdf(invoiceId);
  downloadBlob(data, `Invoice-${invoiceNumber || invoiceId}.pdf`);
};

export const fetchInvoicePreviewHtml = async (invoiceId) => {
  const { data } = await invoicesAPI.getPreviewHtml(invoiceId);
  return data;
};

export const printInvoicePreview = async (invoiceId) => {
  const html = await fetchInvoicePreviewHtml(invoiceId);
  const printWindow = window.open('', '_blank');
  if (!printWindow) {
    throw new Error('Pop-up blocked. Allow pop-ups to print the invoice.');
  }
  printWindow.document.write(html);
  printWindow.document.close();
  printWindow.focus();
  printWindow.onload = () => {
    printWindow.print();
  };
};

export const downloadInvoicePdfForServiceCall = async (serviceCallId, invoiceNumber) => {
  const invoice = await ensureInvoiceForServiceCall(serviceCallId);
  await downloadInvoicePdf(invoice.id, invoiceNumber || invoice.invoiceNumber);
  return invoice;
};

export const printInvoiceForServiceCall = async (serviceCallId) => {
  const invoice = await ensureInvoiceForServiceCall(serviceCallId);
  await printInvoicePreview(invoice.id);
  return invoice;
};
